/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvoiceSchema } from './InvoiceSchema';
import {
    InvoiceSchemaFromJSON,
    InvoiceSchemaFromJSONTyped,
    InvoiceSchemaToJSON,
} from './InvoiceSchema';

/**
 * 
 * @export
 * @interface PaymentHistorySchema
 */
export interface PaymentHistorySchema {
    /**
     * 
     * @type {Array<InvoiceSchema>}
     * @memberof PaymentHistorySchema
     */
    payments: Array<InvoiceSchema>;
}

/**
 * Check if a given object implements the PaymentHistorySchema interface.
 */
export function instanceOfPaymentHistorySchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "payments" in value;

    return isInstance;
}

export function PaymentHistorySchemaFromJSON(json: any): PaymentHistorySchema {
    return PaymentHistorySchemaFromJSONTyped(json, false);
}

export function PaymentHistorySchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentHistorySchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payments': ((json['payments'] as Array<any>).map(InvoiceSchemaFromJSON)),
    };
}

export function PaymentHistorySchemaToJSON(value?: PaymentHistorySchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payments': ((value.payments as Array<any>).map(InvoiceSchemaToJSON)),
    };
}

